<template>
  <div
    class="left_menu left-home"
    :style="needHidLeft1"
    @click="leftMenuClickEv"
  >
    <el-tabs @tab-click="tabClick" v-model="tabActiveName" class="left-menu-tabs" :class="[showMenuTab ? '' : 'left-home-100']">
      <el-tab-pane label="模块" name="first" v-if="showMenuTab">
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item
            v-for="(menu, index) in displayMenuSource"
            :title="menu.name"
            :key="index"
            :name="index + 1"
            v-if="!(menu.name === '布局' && !isLayout)"
          >
            <div :style="needHidLeft2">
              <div>
                <ul class="menu_item_content_ul" @click.stop>
                  <template v-if="menu.name === '收藏'">
                    <li
                      class="left_menu_title"
                      :key="child_index"
                      :data-hhhh="menu"
                      v-for="(container_item, child_index) in menu.children"
                      draggable="true"
                      @dragstart="dragstartEv(container_item, $event)"
                      @dragend="dragendEv"
                      @mousedown="elementMouseDown(container_item, menu.name, $event)"
                      @mouseover="showDeleteIcon(child_index)"
                      @mouseout="hideDeleteIcon"
                    >
                      <img class="menu-icon" :src="collectIcon" alt="" />
                      <p>{{ container_item.title || container_item.name }}</p>
                      <span
                        v-show="showCollectDeleteIconIndex === child_index"
                        class="deleteCollect"
                        @mousedown.stop
                        @click.stop="delCollect(container_item)"
                        ><i class="icon icon-portal-delete"></i
                      ></span>
                    </li>
                  </template>
                  <template v-else-if="menu.name === '布局' && !isLayout">
                    <li
                      class="left_menu_title"
                      :key="child_index"
                      v-for="(container_item, child_index) in menu.children[0].children"
                      v-show="isNeedShow(container_item)"
                      draggable="true"
                      @dragstart="dragstartEv(container_item, $event)"
                      @dragend="dragendEv"
                      @mousedown="elementMouseDown(container_item, menu.name, $event)"
                    >
                      <span class="menu-icon" :class="container_item.attribute.options.thumbnail"></span>
                      <p>{{ container_item.attribute.options.styleName }}</p>
                    </li>
                  </template>
                  <template v-else>
                    <li
                      :class="['left_menu_title', showChosenClass(container_item) ? '' : 'menu_dis_chosen']"
                      :key="child_index"
                      v-for="(container_item, child_index) in menu.children"
                      v-if="container_item.name !== '分页'"
                      v-show="isNeedShow(container_item)"
                      :draggable="canDraggle(container_item)"
                      @dragstart="dragstartEv(container_item, $event)"
                      @dragend="dragendEv"
                      @mousedown="elementMouseDown(container_item, menu.name, $event)"
                    >
                      <span class="menu-icon" :class="menuThumbnail(container_item)"></span>
                      <p>{{ container_item.name }}</p>
                      <span
                        v-if="menu.type === 'global'"
                        class="showChosenClass(menu) ? 'icon-portal-preview-open11' : 'icon-portal-preview-close-one11'"
                      ></span>
                    </li>
                  </template>
                </ul>
                <div v-if="menu.name === '收藏'" class="pagination">
                  <el-pagination
                    small
                    hide-on-single-page
                    layout="prev, pager, next"
                    :page-size="18"
                    @current-change="handleCurrentChange"
                    :total="menu.collectTotal"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-tab-pane>
      <el-tab-pane label="组件" name="first" v-else>
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item
            v-for="(menu, index) in displayMenuSource"
            :title="menu.name"
            :key="index"
            :name="index + 1"
            v-if="!(menu.name === '布局' && !isLayout) && menu.enable && menu.name!=='布局组件'"
          >
            <div :style="needHidLeft2">
              <div>
                <ul class="menu_item_content_ul" @click.stop>
                  <template v-if="menu.name === '收藏'">
                    <li
                      class="left_menu_title"
                      :key="child_index"
                      :data-hhhh="menu"
                      v-for="(container_item, child_index) in menu.children"
                      draggable="true"
                      @dragstart="dragstartEv(container_item, $event)"
                      @dragend="dragendEv"
                      @mousedown="elementMouseDown(container_item, menu.name, $event)"
                      @mouseover="showDeleteIcon(child_index)"
                      @mouseout="hideDeleteIcon"
                    >
                      <img class="menu-icon" :src="collectIcon" alt="" />
                      <p>{{ container_item.title || container_item.name }}</p>
                      <span
                        v-show="showCollectDeleteIconIndex === child_index"
                        class="deleteCollect"
                        @mousedown.stop
                        @click.stop="delCollect(container_item)"
                        ><i class="icon icon-portal-delete"></i
                      ></span>
                    </li>
                  </template>
                  <template v-else-if="(menu.name === '布局') && isLayout">
                    <li
                      class="left_menu_title"
                      :key="child_index"
                      v-for="(container_item, child_index) in menu.children[0].children"
                      v-show="isNeedShow(container_item)"
                      draggable="true"
                      @dragstart="dragstartEv(container_item, $event)"
                      @dragend="dragendEv"
                      @mousedown="
                        elementMouseDown(container_item, container_item.attribute.shape, container_item.attribute, $event)
                      "
                    >
                      <span class="menu-icon" :class="container_item.attribute.options.thumbnail"></span>
                      <p>{{ container_item.attribute.options.name }}</p>
                    </li>
                    <template v-if="layoutComponent">
                      <li
                        class="left_menu_title"
                        :key="'2_'+child_index"
                        v-for="(container_item, child_index) in layoutComponent.children[0].children"
                        v-show="isNeedShow(container_item)"
                        draggable="true"
                        @dragstart="dragstartEv(container_item, $event)"
                        @dragend="dragendEv"
                        @mousedown="
                        elementMouseDown(container_item, container_item.attribute.shape, container_item.attribute, $event)
                      "
                      >
                        <span class="menu-icon" :class="container_item.attribute.options.thumbnail"></span>
                        <p>{{ container_item.name }}</p>
                      </li>
                    </template>
                  </template>
                  <!--                目前屏蔽掉分页 是因为分页做了收藏功能，但是vuex menu中没有 分页，造成后续无法操作，所以将分页放入menu中，此处不展示，后续改造menu，
  将所有组件放入后可删除 v-if="container_item.name!=='分页'"  -->
                  <template v-else>
                    <li
                      :class="['left_menu_title', showChosenClass(container_item) ? '' : 'menu_dis_chosen']"
                      :key="child_index"
                      v-for="(container_item, child_index) in menu.children"
                      v-show="isNeedShow(container_item)"
                      :draggable="canDraggle(container_item)"
                      @dragstart="dragstartEv(container_item, $event)"
                      @dragend="dragendEv"
                      @mousedown="elementMouseDown(container_item, menu.name, $event)"
                    >
                      <span class="menu-icon" :class="menuThumbnail(container_item)"></span>
                      <p>{{ container_item.name }}</p>
                      <span
                        v-if="menu.type === 'global'"
                        class="menu-hidden"
                        :class="showChosenClass(container_item) ? 'icon-portal-preview-open11' : 'icon-portal-preview-close-one11'"
                      ></span>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-tab-pane>
      <el-tab-pane v-if="isPhoneFullScreen" label="页面" name="second">
        <div id="addPhonePage" @click="addContainer">
          <span class="icon icon-portal-plus"></span>
          添加页面
        </div>
        <draggable element="ul" v-model="menuPageList" class="leftPagelist" @end="changeStageIndex">
          <li
            v-for="(children, index) in menuPageList"
            :key="'page_' + index"
            class="verticallyCenter"
            :class="activeStageIndex === index ? 'active' : ''"
            @click="changeActiveStage(children.container_id, index)"
          >
            <div class="flex1">{{ index + 1 }}</div>
            <div class="scan-page"></div>
            <div class="page-handles flex1">
              <el-tooltip
                v-if="!children.options.isEndPage"
                class="item"
                :open-delay="delayTime"
                effect="dark"
                content="克隆当前页面"
                placement="left"
              >
                <span class="icon icon-portal-copy1" @click="copyContainer(children.container_id, index)"></span>
              </el-tooltip>
              <el-tooltip
                v-if="!children.options.isEndPage"
                class="item"
                :open-delay="delayTime"
                effect="dark"
                content="设为模板"
                placement="left"
              >
                <span class="icon icon-portal-template" @click="dialogFormVisible = true"></span>
              </el-tooltip>
              <el-tooltip
                v-if="!children.options.isEndPage"
                class="item"
                :open-delay="delayTime"
                effect="dark"
                content="删除当前页面"
                placement="left"
              >
                <span class="icon icon-portal-delete" @click="delMyContainer(children.container_id)"></span>
              </el-tooltip>
            </div>
            <el-tooltip
              v-if="!children.options.isEndPage"
              class="add-new-stage"
              :open-delay="delayTime"
              effect="dark"
              content="插入空白画布"
              placement="top"
            >
              <el-button
                class="container_btn"
                @click.stop="addContainer(children.container_id)"
                circle
                icon="icon-portal-add_bold"
              ></el-button>
            </el-tooltip>
          </li>
        </draggable>
      </el-tab-pane>
      <!-- 收藏：我的 -->
      <el-tab-pane label="我的" name="fourth" v-if="collectNewVersion">
        <!-- 空数据 -->
        <div class="data-empty tc widthLess18" v-if="collectListEmpty">
          <img :src="emptyListImg" alt="">
          <ul class="fs13 tl">
            <li>1.选中组件后，点击鼠标右键</li>
            <li>2.在下拉菜单中点击“保存到我的样式”</li>
          </ul>
        </div>
        <template v-else>
          <el-checkbox class="padding12" v-model="componentViewType">按分类查看</el-checkbox>
          <!-- 所有数据 -->
          <template v-if="!componentViewType">
            <el-scrollbar ref="scrollbar" style="height: calc(100% - 44px)">
              <div v-if="collectListsAllData.length > 0" class="scroll-container">
                <div class="collect-data-list">
                  <!-- 数据项 -->
                  <div class="data-item mt12 tc"
                      v-for="(item, index) in collectListsAllData"
                      :key="'all_' + index"
                      draggable="true"
                      @dragstart="dragstartEv(item, $event)"
                      @dragend="dragendEv"
                      @mousedown="elementMouseDown(item, '收藏', $event)">
                    <div class="cover-img">
                      <img :src="item.cover" alt="">
                      <el-dropdown class="hover-btn" @command="handleCommand" trigger="click">
                        <span class="icon-portal-more"></span>
                        <el-dropdown-menu slot="dropdown" class="operate-list">
                          <el-dropdown-item :command="{val:'rename', item: item, index: index}">重命名</el-dropdown-item>
                          <el-dropdown-item :command="{val:'delete', item: item, index: index}">删除</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                    <p class="cover-name fs12 overflowHid1"> {{ item.title }}</p>
                  </div>
                </div>
                <div v-if="isLoading" class="loading-text">
                  加载中...
                </div>
              </div>
            </el-scrollbar>
          </template>
          <!-- 分类后的数据 -->
          <template v-if="componentViewType">
            <div class="collect-data-list width222 paddinglr6" v-if="collectListsTypeShow.length > 0">
              <el-collapse v-model="activeNamesCollect" @change="handleChange">
                <el-collapse-item
                    v-for="(item1, index1) in collectListsTypeShow"
                    :title="item1.name"
                    :key="'type_' + index1"
                    :name="index1 + 1"
                    v-if="item1.content.length > 0"
                >
                  <ul class="type-lists">
                    <li class="data-item mt12 tc"
                        v-for="(item2, index2) in item1.content"
                        :key="'type_1_' + index2"
                        draggable="true"
                        @dragstart="dragstartEv(item2, $event)"
                        @dragend="dragendEv"
                        @mousedown="elementMouseDown(item2, '收藏', $event)">
                      <!-- 数据项 -->
                      <div class="cover-img">
                        <img :src="item2.cover" alt="">
                        <el-dropdown class="hover-btn" @command="handleCommand">
                          <span class="icon-portal-more"></span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="{val:'rename', item: item2, index: index1, index2: index2}">重命名</el-dropdown-item>
                            <el-dropdown-item :command="{val:'delete', item: item2, index: index1, index2: index2}">删除</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                      <p class="cover-name fs12 overflowHid1"> {{ item2.title }}</p>
                    </li>
                  </ul>
                  <!-- 查看更多 -->
                  <div v-if="item1.listInfo.pageNum < item1.listInfo.pages"
                      class="btn-more tc lineHeight24 pointer"
                       @click="loadMoreFunc(item1, index1, item1.content.length)">
                    <span class="fs12 color0006">查看更多</span><i class="icon-portal-arrows-down"></i>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </template>
        </template>
      </el-tab-pane>
      <el-tab-pane v-if="isPhoneFullScreen && !isLayout && showPhoneLayer" label="图层" name="third">
        <el-collapse v-model="layerActiveNames">
          <el-collapse-item v-if="checkLayoutStage" title="页面图层" name="1"><stageLayoutLayer /></el-collapse-item>
        </el-collapse>
        <el-collapse v-model="layerActiveNames">
          <el-collapse-item title="画布图层" name="2"><layer /></el-collapse-item>
        </el-collapse>
      </el-tab-pane>
    </el-tabs>
    <!-- 保存画布模块对话框 -->
    <el-dialog
      title="模板的名称"
      :visible.sync="dialogFormVisible"
      :modal-append-to-body="false"
      custom-class="collectDialog"
    >
      <div>
        <el-input v-model="collectModuleForm.name" placeholder="请输入模板的名称"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="saveStageModuleEv">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 收藏重命名 模块对话框 -->
    <el-dialog
        title="样式名称"
        :visible.sync="dialogRenameVisible"
        :modal-append-to-body="false"
        custom-class="collectDialog"
    >
      <div>
        <el-input v-model="collectRenameObj.title" placeholder="请输入收藏名称"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeRenameDialog">取 消</el-button>
        <el-button size="small" type="primary" @click="renameCollectFunc">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import close from "assets/images/close.png"
import stageLayoutLayer from "./stageLayoutLayer.vue"
import layer from "./layer.vue"
import collectIcon from "assets/images/leftMenu/collect.png"
import { deepChangeUid, encryption, decrypt, smartMathMax } from "utils"
import { data_dictionary_map } from "root/static/dataDictionary.js"
import instance from "../../../interceptor"
import { initModules, initStageModules, getBigScreenCollect, getSystemModulesList } from "@/utils/initEv.js"
import {
  primaryAppStageGenerator as primaryappStageGenerator,
  primaryappStagePageLayoutGenerator as primaryappStagePageLayoutGenerator
} from "../../../store/modules/appStage/state"
import {
  primaryStageGenerator as primarystageGenerator,
  primaryStagePageLayoutGenerator as primarystagePageLayoutGenerator
} from "../../../store/modules/stage/state"
import { simpleDeepClone, _throttle } from "../../../utils"
import { reverseBuildModel } from "utils/reverseBuildModel.js"
import { historyCombineWrap } from "utils/revork"
import { button_children } from "materials/button/menus/index"
import Qs from "qs"
const mockData = {
  primaryappStageGenerator,
  primarystageGenerator,
  primaryappStagePageLayoutGenerator,
  primarystagePageLayoutGenerator
}

export default {
  name: "left-menu.vue",
  props: {
    menuSource: { type: Array, default: [] }
  },
  components: {
    layer,
    stageLayoutLayer,
    draggable
  },
  data() {
    return {
      tabActiveName: "first",
      layerActiveNames: [],
      activeNames2: [],
      activeNames: [1, 2, 3, 4, 5],
      needHid: false,
      mouseOverDel: false,
      needHidLeft1: null,
      needHidLeft2: null,
      closeImage: close,
      collectIcon: collectIcon,
      nameControl: true,
      doAdd: false,
      dataSource: this.menuSource,
      scrollHeight: null,
      showCollectDeleteIconIndex: null,
      dialogFormVisible: false,
      collectModuleForm: {
        name: null,
        type: 100
      },
      delayTime: 1000,
      activeNamesCollect: [],
      componentViewType: false,  //左侧栏我的（收藏）数据按照分类查看
      collectListsAllData: [], // 数据列表
      collectListsTypeData: [], //分类的数据列表
      collectListsTypeShow: [], //分类的数据列表
      isLoading: false, // 是否正在加载
      totalPage: undefined, //总页码
      allStyleLen: 0,
      curPage: 1, // 当前页码
      pageSize: 10, // 每页数据量
      hasMore: true, // 是否有更多数据
      emptyListImg: require("assets/images/empty-template.png"),
      collectListEmpty: false,
      dialogRenameVisible: false, //我的【收藏】模块 重命名
      collectRenameObj: {
        title: "",
        publicId: "",
        cover: "",
        itemPath: ""
      },
      styleIdArr1: [],
      firstTimeTabFourth: true,
      collectNewVersion: true,   //是否使用收藏新交互
    }
  },
  created() {},
  watch: {
    componentViewType: function (newVal, oldVal) {
      this.getAllStyles(newVal)
    },
    displayMenuSource: {
      deep: true,
      handler(n, o) {
        this.collectListsAllData = []
        this.getAllStyles(this.componentViewType)
      }
    }
  },
  mounted() {},
  computed: {
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    isLayout() {
      if (this.isPhoneFullScreen) {
        // 翻页模版不能设置为布局模式
        return false
      }
      return this.$store.state[this.request_prefix].page.pageLayoutType
    },
    checkLayoutStage() {
      return this.$store.state[this.request_prefix].page?.layoutOption?.rows
    },
    stageSource() {
      return this.$store.state[this.request_prefix].page.children
    },
    isPhoneFullScreen() {
      return this.$store.state[this.request_prefix].page.isPhoneFullScreen
    },
    showMenuTab() {
      return this.isPhoneFullScreen ? true : false
    },
    menuPageList: {
      get() {
        return JSON.parse(JSON.stringify(this.stageSource))
      },
      set(val) {}
    },
    activeStageIndex() {
      for (let i = 0; i < this.menuPageList.length; i++) {
        if (this.menuPageList[i].isActive) {
          return i
        }
      }
      return 0
    },
    isShowContent() {
      return this.menuSource.map(item => item.isActive).indexOf(true)
    },
    ids() {
      return this.$store.state.states.activeID
    },
    menuThumbnail() {
      return function (containerItem) {
        return containerItem.thumbnail
          ? containerItem.thumbnail
          : containerItem.children && containerItem.children.length > 0
          ? containerItem.children[0]?.thumbnail
          : ""
      }
    },
    bayWindowOpen() {
      return !!this.$store.state[this.request_prefix].page?.global?.bayWindowOpen
    },
    showChosenClass() {
      return function (menu) {
        let show = true
        switch (menu.type) {
          case "cxBayWindow":
            show = this.bayWindowOpen
            break
          case "cxHeader":
            show = this.isShowHeader
            break
          case "cxFooter":
            show = this.isShowFooter
            break
          case "cxAnchor":
            show = this.isShowAnchor
            break
          case "cxSmartServices":
            show = this.showSmartServices
            break
          case "cxGoTop":
            show = this.isShowGotop
            break
          default:
        }
        return show
      }
    },
    pageLayoutList: {
      get() {
        return this.$store.state[this.request_prefix].page.pageLayoutList
      },
      set(val) {
        this.$store.dispatch(this.request_prefix + "/changePageLayout", { pageLayoutList: val })
      }
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    displayMenuSource() {
      let params = {
        admin: this.$store.state.states.managerType == 1 ? true : false,
        isSubHeadPage: this.$store.state[this.request_prefix].page.isSubHeadPage
      }
      if (this.pageType === "detailPage") { // 详情页需要屏蔽的业务组件
        params.detailPageBusinessFlag = false
      }
      if (this.pageType === "listPage") { // 列表页需要屏蔽的业务组件
        params.listPageBusinessFlag = false
      }
      if (this.pageType === "normal") { // 首页需要屏蔽的业务组件
        params.homePageBusinessFlag = false
      }
      if (this.isPhoneFullScreen) { // 翻页模板需要屏蔽的业务组件
        params.phoneFullScreenFlag = false
      }
      let menuSource = JSON.parse(JSON.stringify(this.menuSource))
      // if(this.pageType === 'listPage' || this.pageType === 'detailPage'){
      const isWaterFall = this.$store.state[this.request_prefix].page.isWaterFall === 'waterFall' ? true : false
      if(!isWaterFall){
        menuSource = this.menuSource.filter(item=> item.name !== '布局' || (item.name === '布局' && item.isOldPageLayout))
      }else{
        menuSource = this.menuSource.filter(item=> item.name !== '布局' || (item.name === '布局' && !item.isOldPageLayout))
      }

      const source = menuSource.map(item => {
        // 隐藏整个分类下的组件
        let enable = item.enable
        if (enable === undefined || enable === null) enable = true
        if (typeof enable === "function") {
          enable = enable(params)
        }
        const _item = Object.assign({}, item, { children: [] })
        _item.enable = enable
        _item.children = enable && item.children
          .filter(sub_menu => {
            //首页替换列表页搜索的插件名称
            let sub_menu1 = JSON.parse(JSON.stringify(sub_menu))
            if(sub_menu1.type === "cxSimpleSearchState" ){
              if(this.pageType !== 'listPage' && this.pageType !== 'detailPage'){
                let pluginNameArr = sub_menu.children[0].attribute.options.pluginName
                if(pluginNameArr.indexOf("ListPageSearchComponentPlugin") > -1 && pluginNameArr.indexOf("HomePageSearchComponentPlugin") < 0){
                  pluginNameArr.push("HomePageSearchComponentPlugin")
                }
              }
            }

            const enable = sub_menu.enable
            // 如果enable没有定义，则默认为显示，如果enable为函数则传入参数取值
            if (enable === undefined || enable === null) return true
            if (typeof enable === "function") {
              return enable(params)
            }
            return enable
          })
          .sort((a, b) => (a.sort || 0) - (b.sort || 0))
        return _item
      })
      return source
    },
    layoutComponent(){
      const isWaterFall = this.$store.state[this.request_prefix].page.isWaterFall  === 'waterFall' ? true : false
      if(!isWaterFall){
        return null
      }
      return this.displayMenuSource.find(item=>item.name === '布局组件') || null
    },
    showPhoneLayer() {
      return this.$store.state.states.showPhoneLayer
    },
    styleIdArr() {
     let styleIdArr = []
      this.styleIdArr1 = []
      let menu = this.request_prefix === "appStage" ? this.$store.state.appMenu.menu : this.$store.state.menu.menu
      let moduleTypes = menu.moduleTypes
      moduleTypes?.find(item => {
        if(item.subs && item.subs.length > 0){
          let subs = item.subs
          subs.forEach((item1)=>{
            if(item1.name.indexOf("我的") > -1){
              styleIdArr.push({name: item.name, publicId: item1.publicId, typeId: item1.id, parentPublicId: item.publicId})
              this.styleIdArr1.push(item1.publicId)
            }
          })
        }
      })
      return styleIdArr
    },
    isShowHeader: {
      get() {
        const index = this.pageLayoutList?.findIndex(pageLayout => pageLayout.options.inDocument === "header")
        if (index === -1) return false
        return this.$store.state[this.request_prefix].page.isShowHeader || false
      },
      set(newVal) {
        historyCombineWrap(() => {
          this.$changePageAttribute({ option_name: "isShowHeader", option_val: newVal })
          if (this.isLayout) {
            // 布局模式
            this.layoutChangeShowBaseStatus("header", newVal)
            // 取消头部显示，同时取消引用
            if (["listPage", "detailPage", "equalPage"].includes(this.pageType) && !newVal) {
              const headerIndex = this.pageLayoutList.findIndex(pageLayout => pageLayout.options.inDocument === "header")
              this.$changeOptionsEV([false], ["isRefHome"], false, "", {
                containerId: 0,
                pageLayoutId: headerIndex
              })
            }
          } else {
            // 多画布模式
            this.changeShowBaseStatus("header", newVal)
          }
        })()
      }
    },
    isShowFooter: {
      get() {
        const index = this.pageLayoutList?.findIndex(pageLayout => pageLayout.options.inDocument === "footer")
        if (index === -1) return false
        return this.$store.state[this.request_prefix].page.isShowFooter || false
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "isShowFooter", option_val: newVal })
        if (this.isLayout) {
          // 布局模式
          this.layoutChangeShowBaseStatus("footer", newVal)
          // 取消头部显示，同时取消引用
          //
          if (["listPage", "detailPage", "equalPage"].includes(this.pageType) && !newVal) {
            const footerIndex = this.pageLayoutList.findIndex(pageLayout => pageLayout.options.inDocument === "footer")
            this.$changeOptionsEV([false], ["isRefHome"], false, "", {
              containerId: 0,
              pageLayoutId: footerIndex
            })
          }
        } else {
          // 多画布模式
          this.changeShowBaseStatus("footer", newVal)
        }
      }
    },
    isShowAnchor: {
      get() {
        const index = this.pageLayoutList?.findIndex(pageLayout => pageLayout.options.inDocument === "anchor")
        if (index === -1) return false
        return this.$store.state[this.request_prefix].page.isShowAnchor || false
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "isShowAnchor", option_val: newVal })
        if (this.isLayout) {
          // 布局模式
          this.layoutChangeShowBaseStatus("anchor", newVal)
        } else {
          // 多画布模式
          this.changeShowBaseStatus("anchor", newVal)
        }
      }
    },
    isShowGotop: {
      get() {
        return this.$store.state[this.request_prefix].page.isShowGotop || false
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "isShowGotop", option_val: newVal })
      }
    },
    showSmartServices: {
      get() {
        return this.$store.state[this.request_prefix].page.showSmartServices || false
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "showSmartServices", option_val: newVal })
      }
    }
  },
  methods: {
    handleCurrentChange(index) {
      getBigScreenCollect.call(this, index)
    },
    setMouseOver(name) {
      if (name === "页面设置" && this.isShowContent === -1) {
        this.nameControl = false
      }
    },
    mouseleave(name) {
      if (name === "页面设置" && this.isShowContent === -1) {
        this.nameControl = true
      }
    },
    // 控制menu选中时右侧文字宽度
    fixMenuCircleW() {
      this.$nextTick(() => {
        const rootDoc = document.getElementsByClassName("left_menu")[0]
        const tabs = rootDoc.getElementsByClassName("el-tabs__item is-left")
        for (let i = 0; i < tabs.length; i++) {
          if (tabs[i].offsetWidth !== 0) {
            tabs[i].style.width = tabs[i].innerText.length * 14 + 24 + "px"
          }
        }
      })
    },
    closeMenu(index) {
      this.$store.dispatch("menu/unsetActive", { id: index })
    },
    tabClick(tab) {
      if (this.isPhoneFullScreen && tab.index == 1) {
        initStageModules.call(this)
      }
      this.$store.dispatch(this.request_prefix + "/changeStageLayoutOption", {
        key: "buttonContextUid",
        value: ""
      })
      if(this.collectNewVersion && this.firstTimeTabFourth && this.tabActiveName === "fourth"){
        this.getAllStyles(false)
        this.firstTimeTabFourth = false
      }
    },
    leftMenuClickEv() {
      if (this.$store.state.states.changeToolBarStatus) {
        this.$store.commit("states/changeToolBarStatus", false)
      }
      if (this.$store.state.states.changeAlignHelperStatus) {
        this.$store.commit("states/changeAlignHelperStatus", false)
      }
    },
    handleOpen($event, tempId) {
      // 获取当前元素
      const acId = this.$store.getters["menu/getActiveMenu"]
      const index = $event ? Number($event.currentTarget.attributes["index"].nodeValue) : null
      this.id = index !== null ? index : this.id
      if (tempId === acId) {
        this.$store.dispatch("menu/unsetActive", { id: tempId })
      } else {
        this.$store.dispatch("menu/setActive", { id: tempId == 321 ? tempId : this.id })
        this.fixMenuCircleW()
        this.nameControl = true
      }
    },
    getActiveMenu() {
      let len = this.$store.state.menu.menu.children.length,
        item = this.$store.state.menu.menu.children,
        result = null
      for (let i = 0; i < len; i++) {
        if (item[i].isActive) {
          result = i
          break
        }
      }
      return result
    },

    changeStageIndex(evt) {
      console.log(evt)
      this.$store.dispatch(
        this.request_prefix + "/changeContainerPosition",
        JSON.parse(
          JSON.stringify({
            type: "move",
            newIndex: evt.newIndex,
            oldIndex: evt.oldIndex
          })
        )
      )
    },
    addContainer(id) {
      let isAddSystemEndPage = this.$store.state[this.request_prefix].page.isAddSystemEndPage
      let lastContainerId = isAddSystemEndPage
        ? this.stageSource[this.stageSource.length - 2].container_id
        : this.stageSource[this.stageSource.length - 1].container_id
      let thisId = typeof id !== "number" ? lastContainerId : id
      const param = {
        container_data: new mockData["primary" + this.request_prefix + "Generator"](),
        id: thisId
      }
      if (this.isPhoneFullScreen) {
        param.container_data.options.containerAnimateSet = {
          direction: "upDown",
          animateType: "regular",
          animateClass__pageUp: "up",
          animateClass__pageDown: "down",
          nextAnimateClass: "",
          prevAnimateClass: "",
          isAutoPlay: false,
          autoPlayDelay: 3
        }
      }
      this.$store.dispatch(this.request_prefix + "/insertContainer", JSON.parse(JSON.stringify(param)))
    },
    copyContainer(id, index) {
      let isAddSystemEndPage = this.$store.state[this.request_prefix].page.isAddSystemEndPage
      let lastContainerId = isAddSystemEndPage
        ? this.stageSource[this.stageSource.length - 2].container_id
        : this.stageSource[this.stageSource.length - 1].container_id
      let thisId = typeof id === "undefined" ? lastContainerId : id
      const param = {
        container_data: JSON.parse(JSON.stringify(this.stageSource[index])),
        id: thisId
      }
      this.$store.dispatch(this.request_prefix + "/insertContainer", JSON.parse(JSON.stringify(param)))
    },
    changeActiveStage(id, index) {
      // 选中当前容器
      const _stage = this.$store.state[this.request_prefix]
      if (!this.getAttrById(_stage, { container_id: id })?.isActive) {
        this.$store.commit("states/changeActiveID", { container_id: id })
      }
      this.$store.dispatch(this.request_prefix + "/setContainerActive", { container_id: id })
      this.$store.commit("states/changeElementType", "container")
      this.$store.commit("states/clearHistoryState")
    },
    delMyContainer(id) {
      // 删除画布
      const _stage = this.$store.state[this.request_prefix]
      if (this.getAttrById(_stage, { container_id: id }).isActive) {
        this.$store.commit("states/changeActiveID", null)
      }
      this.$store.dispatch(this.request_prefix + "/deleteContainer", id)
      this.$store.commit("states/clearHistoryState")
    },
    async dragstartEv(item, e) {
      const _self = this
      const shape = item.type || this?.rectAttr?.shape
      this.$store.commit("states/changeLeftMenuDragStatu", true)
      // 关闭右侧栏
      // if(!this.ids.uid){
      //   this.$store.commit("states/changeShowRightToolbarStfatus", false)
      // }
      sessionStorage.setItem("isDragging", true)
      e.dataTransfer.effectAllowed = "copyMove"
      e.dataTransfer.setData("rectAttribute", JSON.stringify(this.rectAttr))
      localStorage.setItem("dragType", shape)
      localStorage.setItem("dragTypeData", JSON.stringify(this.rectAttr))
      if(this.rectAttr  && this.rectAttr.options && this.rectAttr.options.height){
        // 用于基础组件拖入布局中，判断新生成栅格的大小
        localStorage.setItem("dragRectHeight", this.rectAttr.options.height)
      }
      //  考虑布局拖入页面的交互效果差异   e.dataTransfer 在dragover事件中获取为空
      if (this.rectAttr?.shape === "cxPageLayout") {
        localStorage.setItem("dragType", "cxPageLayout")
      }
      setImmediate(() => {
        _self.showStatus = false
      })
    },
    dragendEv(e) {
      this.showStatus = true
      sessionStorage.removeItem("isDragging")
      sessionStorage.removeItem("dropOverCell")
      this.$eventBus.$emit('addDragEnd', {x: e.clientX, y: e.clientY, options: this.rectAttr, e: e})
      localStorage.removeItem("dragType")
      localStorage.removeItem("dragTypeData")
      this.$store.commit("states/changeLeftMenuDragStatu", false)
    },
    // 门户2.0的收藏componentTypeId与大屏不同需要从菜单树结构查找对应关系
    // 根据收藏时用到的我的分类的数据来查找对应的分类，实现组件拖到画布后有对应的样式选择数据
    getRelativeTypeId(typeId) {
      let relativeTypeId = ""
      if(this.styleIdArr.length > 0){
        this.styleIdArr.find(item=>{
          if(item.typeId === typeId){
            relativeTypeId = item.parentPublicId
          }
        })
      }
      return relativeTypeId
    },
    //鼠标按下
    elementMouseDown(childItem, childTypeName, e) {
      sessionStorage.removeItem("isGridDragOver")
      let attribute
      // 系统样式 需要调用样式列表接口
      let childItemInfo = {
        // childItemTypeId: childItem.typeId,
        childItemTypeId: childTypeName === "收藏" ? this.getRelativeTypeId(childItem.typeId) : childItem.typeId,
        childItemTypeName: childItem.type,
        childItemTitle: childTypeName === "收藏" ? childItem.title : childItem.name,
        childItemName: childTypeName === "收藏" ? "收藏" : childItem.name
      }
      sessionStorage.setItem("childItemInfo", JSON.stringify(childItemInfo))
      const isGlobal = childItem.type === "cxBayWindow" || childItem.type === "cxHeader" || childItem.type === "cxFooter" || childItem.type === "cxAnchor" || childItem.type === "cxSmartServices" || childItem.type === "cxGoTop"
      if (childItem.children?.length === 0 && childItem.typeId) {
        this.rectAttr = undefined
        return
      } else {
        if (childTypeName === "布局" || childTypeName === "cxPageLayout" || isGlobal || childTypeName === "cxPageLayoutComponent") {
          attribute = childItem.attribute
        } else if (childTypeName === "收藏") {
          this.rectAttr = childItem
          return
        } else {
          attribute = childItem.children[0]?.attribute
        }
      }
      const _attribute = JSON.parse(JSON.stringify(attribute))

      this.resetRectAttrOpt(childItem, _attribute)
      if (childItem.type === "cxSmartServices") {
        this.showSmartServices = !this.showSmartServices
        this.handleSmartServices()
      }
      if (childItem.type === "cxBayWindow") {
        this.$store.dispatch(this.request_prefix + "/changeBayWindowStatus")
        this.handleBayWindow()
      }
      if (childItem.type === "cxHeader") {
        this.isShowHeader = !this.isShowHeader
      }
      if (childItem.type === "cxFooter") {
        this.isShowFooter = !this.isShowFooter
      }
      if (childItem.type === "cxAnchor") {
        this.isShowAnchor = !this.isShowAnchor
      }
      if (childItem.type === "cxGoTop") {
        this.isShowGotop = !this.isShowGotop
        this.handleGoTop()
      }
    },
    handleSmartServices() {// 处理机器人
      const smartServicesLayout = this.pageLayoutList.find(layout => layout.options.smartServices)
      if (this.showSmartServices) {
        this.$store.commit("states/changeShowRightToolbarStatus", true)
        if (smartServicesLayout) {
          smartServicesLayout.options.isShow = false
          const id = this.pageLayoutList.findIndex(layout => layout.options.smartServices)
          this.$store.commit("states/changeActiveID", { container_id: 0, pageLayoutId: id })
          this.$store.commit("states/changeElementType", "cxPageLayout")
        } else {
          //创建一个新的通栏和布局。（注：没有新增布局组件，直接在通栏实现）
          let layoutList = new mockData["primary" + this.request_prefix + "PageLayoutGenerator"](
            this.rectAttr.options.type
          )
          layoutList.id = this.getNewLayoutId()
          layoutList.options.smartServices = true
          layoutList.options.isShow = false
          // 有底部，放底部前面；没有放最前面
          const footerIndex = this.pageLayoutList.findIndex(pageLayout => pageLayout.options.inDocument === "footer")
          const len = this.pageLayoutList.length - 1
          this.pageLayoutList.splice(
          footerIndex === -1 ? len : footerIndex,
            0,
            JSON.parse(JSON.stringify(layoutList))
          )
          const id = this.pageLayoutList.findIndex(layout => layout.options.smartServices)
          this.$store.commit("states/changeActiveID", { container_id: layoutList.id, pageLayoutId: id })
          this.$store.commit("states/changeElementType", "cxPageLayout")
        }
      } else {
        this.$store.commit("states/changeShowRightToolbarStatus", false)
        smartServicesLayout.options.isShow = false
      }
    },
    // 处理飘窗开关状态
    handleBayWindow() {
      const bayWindowIndex = this.pageLayoutList.findIndex(layout => layout.options.enableBayWindow)
      if (this.bayWindowOpen) {
        if (this.pageLayoutList[bayWindowIndex]) {
          this.pageLayoutList[bayWindowIndex].options.isShow = true
          this.$store.commit("states/changeActiveID", { container_id: 0, pageLayoutId: this.pageLayoutList[bayWindowIndex].id })
          this.$store.commit("states/changeElementType", "cxPageLayout")
        } else {
          // 如果飘窗还不存在，创建一个新的通栏和布局。（注：飘窗没有新增布局组件，直接在通栏实现）
          let layoutList = new mockData["primary" + this.request_prefix + "PageLayoutGenerator"](
            this.rectAttr.options.type
          )
          layoutList.id = this.getNewLayoutId()
          layoutList.options.enableBayWindow = true
          if(this.request_prefix === "appStage"){
            layoutList.options.bayWidth = 240
            layoutList.options.bayHeight = 135
          }else{
            layoutList.options.bayWidth = 400
            layoutList.options.bayHeight = 225
          }

          layoutList.options.bayStartPosition = "topLeft"
          layoutList.options.bayMoveSpeed = "high"
          layoutList.options.bayManualClose = false
          layoutList.options.padding = [0, 0, 0, 0]
          layoutList.layout.rows[0].options.height = 225
          // 有头部，放头部后面；没有，放最前面
          const headerIndex = this.pageLayoutList.findIndex(pageLayout => pageLayout.options.inDocument === "header")
          this.pageLayoutList.splice(
            headerIndex === -1 ? 0 : headerIndex + 1,
            0,
            JSON.parse(JSON.stringify(layoutList))
          )
          this.$store.commit("states/changeActiveID", { container_id: 0, pageLayoutId: layoutList.id })
          this.$store.commit("states/changeElementType", "cxPageLayout")
        }
      } else {
        this.pageLayoutList[bayWindowIndex].options.isShow = false
        // 修复旧数据，保证头部在飘窗前面
        const headerIndex = this.pageLayoutList.findIndex(pageLayout => pageLayout.options.inDocument === "header")
        if (headerIndex > bayWindowIndex) {
          const temp = this.pageLayoutList[bayWindowIndex]
          this.pageLayoutList[bayWindowIndex] = this.pageLayoutList[headerIndex]
          this.pageLayoutList[headerIndex] = temp
        }
      }
    },
    // 处理回到顶部开关状态
    handleGoTop() {
      const goTopLayout = this.pageLayoutList.find(layout => layout.options.inDocument === "goTop")
      if (this.isShowGotop) {
        if (goTopLayout) {
          goTopLayout.options.isShow = true
          this.$store.commit("states/changeShowRightToolbarStatus", true)
          this.$store.commit("states/changeActiveID", {
            container_id: 0,
            rect_id: goTopLayout.layout.rows[0].rectIds[0]
          })
          this.$store.commit("states/changeElementType", "cxButton")
        } else {
          // 如果回到顶部还不存在，创建一个新的通栏和布局。（注：回到顶部没有新增布局组件，直接在通栏实现）
          let layoutList = new mockData["primary" + this.request_prefix + "PageLayoutGenerator"](
            this.rectAttr.options.type
          )
          layoutList.id = this.getNewLayoutId()
          layoutList.options = {
            ...layoutList.options,
            inDocument: "goTop",
            positionType: "fixed",
            width: 100,
            height: 36,
            padding: [0, 0, 0, 0],
            pBottom: "0%",
            pLeft: "auto",
            pRight: "0%",
            pTop: "auto",
            pxOffset: ["自动", 20, 40, "自动"]
          }
          layoutList.layout.rows[0].options.height = 36

          // 需要添加一个按钮组件，控制弹出框的显示
          const allRects = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
            container_id: 0
          }).children
          let _rect_id = -1
          if (allRects.length > 0) {
            _rect_id = smartMathMax(
              ...allRects.map(function (o) {
                return o.rect_id
              })
            )
          }
          let rect_id = _rect_id + 1
          const button = simpleDeepClone(button_children[0].attribute)
          button.options = {
            ...button.options,
            content: "回到顶部",
            pluginName: ["goTopPlugin"],
            isQuickSite: true,
            top: 100,
            topType: "%",
            left: 100,
            leftType: "%",
            margin: ["-100%", 0, 0, "-100%"],
            offset: [0, 20, 40, 0],
            cursorType: "pointer"
          }
          const params = {
            containerID: 0,
            data: button
          }
          this.$store.dispatch(this.request_prefix + "/addElement", params)

          // 有头部，放头部后面；没有，放最前面
          layoutList.layout.rows[0].rectIds.push(rect_id)
          const headerIndex = this.pageLayoutList.findIndex(pageLayout => pageLayout.options.inDocument === "header")
          this.pageLayoutList.splice(headerIndex === -1 ? 0 : headerIndex + 1, 0, simpleDeepClone(layoutList))
          this.$store.commit("states/changeShowRightToolbarStatus", true)
          this.$store.commit("states/changeActiveID", {
            container_id: 0,
            rect_id: rect_id
          })
          this.$store.commit("states/changeElementType", "cxButton")
        }
      } else {
        goTopLayout.options.isShow = false
      }
    },
    // 多画布模式显示/添加头，底
    changeShowBaseStatus(type, statu) {
      let hasBaseStage = false
      let _index, thisId
      switch (type) {
        case "header":
          _index = 0
          thisId = -1
          break
        case "footer":
          _index = this.stageSource.length - 1
          thisId = this.stageSource[this.stageSource.length - 1].container_id
          break
        default:
      }
      if (this.stageSource[_index].options?.inDocument && this.stageSource[_index].options.inDocument === type) {
        this.$changeOptionsEV(statu, "isShow", false, "", {
          containerId: this.stageSource[_index].container_id
        })
        hasBaseStage = true
      }
      // 去掉脏数据，针对某些页面有两个头或者底的情况 提前删除
      for (let i = 0; i < this.stageSource.length; i++) {
        if (
          i !== _index &&
          this.stageSource[i].options?.inDocument &&
          this.stageSource[i].options.inDocument === type
        ) {
          this.$store.dispatch(this.request_prefix + "/deleteContainer", this.stageSource[i].container_id)
        }
      }
      if (!hasBaseStage) {
        // 新加头底为上传上传样式的第一个
        this.getFirstStyle(type, statu, _index)
      }
    },
    // 布局模式显示/添加头，底
    layoutChangeShowBaseStatus(type, statu) {
      let pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
      let hasBaseStage = false
      const _index = pageLayoutList.findIndex(layout => layout.options.inDocument === type)
      if (_index > -1) {
        this.$changeOptionsEV(statu, "isShow", false, "", {
          containerId: 0,
          pageLayoutId: _index
        })
        hasBaseStage = true
        if (type === "anchor" && statu) {
          this.initAnchor(pageLayoutList[_index])
        }
      }
      // 去掉脏数据，针对某些页面有两个头或者底的情况 提前删除
      for (let i = 0; i < pageLayoutList.length; i++) {
        if (i !== _index && pageLayoutList[i].options?.inDocument && pageLayoutList[i].options.inDocument === type) {
          this.delElementHandle(pageLayoutList[i])
          this.pageLayoutList.splice(i, 1)
          this.$store.dispatch(this.request_prefix + "/changePageLayout", { pageLayoutList: pageLayoutList })
        }
      }

      if (!hasBaseStage) {
        // 新加头底为上传上传样式的第一个
        this.getFirstStyle(type, statu, _index)
      }
    },
    delElementHandle(cellVal) {
      let rectIds = cellVal.rectIds ? JSON.parse(JSON.stringify(cellVal.rectIds)) : []
      rectIds.forEach(item => {
        let param = {
          container_id: this.ids.container_id,
          rect_id: item,
          record: false
        }
        this.$store.dispatch(this.request_prefix + "/deleteElement", param)
      })
      cellVal.layout.rows?.forEach(item => {
        if (item.rectIds && item.rectIds.length > 0) {
          this.delElementHandle(item)
        }
      })
      cellVal.layout.cols?.forEach(item => {
        if (item.rectIds && item.rectIds.length > 0) {
          this.delElementHandle(item)
        }
      })
    },
    // 获取第一个头底样式
    async getFirstStyle(type, statu, index) {
      let _index = index
      // 开发环境
      let publicId = null
      switch (type) {
        case "header":
          _index = 0
          publicId = "5d52ad323d52c111ed0892b497c05e04f203"
          break
        case "footer":
          _index = this.pageLayoutList.length
          publicId = "620d00f37d52c111ed0892b6bd352c6b409e"
          break
        case "anchor":
          publicId = "f9afdbee04bcb311ee1a3c0737a3a8ab788f"
        default:
      }
      let firstModuleEnc = await this.getFirstPageLayoutEncId.call(this, publicId)
      let content = firstModuleEnc.content
      let rects = content.rects
      rects.forEach(item => {
        //还原被encryption方法加密过json字符串
        item.shape = decrypt(item.shape, data_dictionary_map)
        //将json中的rem转为px
        reverseBuildModel(item.shape)
      })
      let newPageLayout = firstModuleEnc?.content?.pageLayout
      newPageLayout.options.inDocument = type
      newPageLayout.options.isShow = statu
      newPageLayout.id = this.getNewLayoutId()
      newPageLayout = await this.handleRect(newPageLayout, rects)
      if (type === "anchor") {
        newPageLayout.options.isFixed = true
        newPageLayout.options.childSizeAuto = true
        // 渲染锚点组件内按钮的个数
        this.initAnchor(newPageLayout)
      }
      this.$store.dispatch(this.request_prefix + "/insertPageLayout", {
        pagelayout_data: newPageLayout,
        index: _index
      })
    },
    // 获取通栏的指定分类下的第一个数据
    async getFirstPageLayoutEncId(encTypeId) {
      let data
      await this.$API
        .queryFirstComponentContent({
          encId: encTypeId
        })
        .then(res => {
          if (res.data.code === 1) {
            data = res.data.data.moduleContent
            if (data !== undefined && data.content && data.content.length > 30) {
              //还原被encryption方法加密过json字符串
              data.content = decrypt(data.content, data_dictionary_map)
              //将json中的rem转为px
              reverseBuildModel(data.content)
            }
          }
        })
      return data
    },
    initAnchor(newPageLayout) {
      // 排除用fixed定位的通栏、被隐藏的通栏、锚点通栏
      let pageListLen = 0
      this.pageLayoutList.forEach(pageLayout => {
        let type = pageLayout.options.inDocument
        if (type !== "anchor" && pageLayout.options.position !== "fixed" && pageLayout.options.isShow) {
          pageListLen++
        }
      })
      let rectIds = newPageLayout?.layout?.rows[0]?.rectIds
      let rectIdsLen = newPageLayout?.layout?.rows[0]?.rectIds?.length
      let elementList = []
      if (rectIds) {
        rectIds.forEach(item => {
          elementList.push(
            this.$store.state[this.request_prefix].page.children[0].children.find(rect => rect.rect_id === item)
          )
        })
      }
      console.log("pageList :>>", pageListLen, rectIdsLen, rectIds, rectIds?.length)
      if (pageListLen < rectIdsLen - 2) {
        // 通栏数小于锚点数 减少锚点个数
        let len = rectIdsLen - 2 - pageListLen
        rectIds.splice(pageListLen, len)
      } else if (pageListLen > rectIds?.length - 2) {
        // 通栏数大于锚点数 添加锚点个数
        let index = rectIdsLen > 2 ? rectIdsLen - 2 : 0
        let len = pageListLen - (rectIdsLen - 2)
        let param = {
          active: false,
          draggable: false,
          hoverZIndex: 1,
          parentLim: true,
          resizable: true,
          shape: "cxButton",
          options: JSON.parse(JSON.stringify(elementList[0]?.options))
        }
        for (var i = 0; i < len; i++) {
          if (Number(index + 1 + i) < 10) {
            param.options.content = "0" + Number(index + 1 + i)
          } else {
            param.options.content = Number(index + 1 + i)
          }
          this.addNewRect(
            {
              rectAttr: param,
              cellRect: rectIds,
              index: Number(index + i),
              isClone: false
            },
            "",
            "addBtn"
          )
        }
      }
    },
    async handleRect(newLayout, rects) {
      newLayout.layout.rows?.forEach(row => {
        return this.handleRect(row, rects)
      })
      newLayout.layout.cols?.forEach(col => {
        return this.handleRect(col, rects)
      })
      for (let j = 0; j < newLayout?.rectIds?.length; j++) {
        const item = newLayout.rectIds[j]
        for (let i = 0; i < rects.length; i++) {
          if (rects[i].shape.rect_id === item) {
            await this.addNewRect({
              rectAttr: rects[i].shape,
              cellRect: newLayout.rectIds,
              index: j,
              isClone: false
            })
          }
        }
      }
      return newLayout
    },
    // 新加入rect
    async addNewRect(param, e, type) {
      let rectAttr = JSON.parse(JSON.stringify(param.rectAttr))
      // 如果当前数据中存在appId判断当前组件是否是系统保存好的样式
      if (rectAttr.options.myFetchParam?.appId || rectAttr.options.appId) {
        //更新appid
        const appId = rectAttr.options.appId ? rectAttr.options.appId : rectAttr.options.myFetchParam?.appId
        // 需要判断当前组件类型，如果是基于自由布局开发的搜索组件/导航菜单，需要特殊处理
        const isSearchComponent = rectAttr.options.pluginName?.includes("searchComponentPlugin")
        const isNavComponent = rectAttr.shape.toLowerCase().includes("nav")
        const res = await this.$styleToSaveModule(
          "31CB73E03E24BBFF",
          "临时",
          appId,
          param.isClone,
          isSearchComponent,
          isNavComponent
        )
        if (!!res.appId) {
          // 没有myfetchparam的组件 比如搜索组件 更新appId
          rectAttr.options.appId = res.appId
          //如果拖入画布的组件有，myfetchparam，证明是自由布局或者轮播
          //则pageId,wfwfid,websiteId,更新为当前页面的值，防止老组件id不兼容
          // if (rectAttr?.options?.myFetchParam) {
          //   const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
          //   rectAttr.options.appId = res.appId
          //   rectAttr.options.moduleId = res.moduleId
          //   rectAttr.options.myFetchParam.pageId = pageId
          //   rectAttr.options.myFetchParam.wfwfid = wfwfid
          //   rectAttr.options.myFetchParam.websiteId = websiteId
          //   rectAttr.options.myFetchParam.appId = res.appId
          // }
          const params = {
            containerID: this.ids.container_id,
            data: rectAttr
          }
          this.$store.dispatch(this.request_prefix + "/addElement", params).then(res => {})

          let newIndex = param.index
          const allRects = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
            container_id: this.ids.container_id
          }).children
          let _rect_id = -1
          if (allRects.length > 0) {
            _rect_id = smartMathMax(
              ...allRects.map(function (o) {
                return o.rect_id
              })
            )
          }
          let rect_id = _rect_id
          if (typeof newIndex !== "undefined") {
            param.cellRect.splice(newIndex, 1, rect_id)
          } else {
            param.cellRect.push(rect_id)
          }
        }
      } else {
        const params = {
          containerID: this.ids.container_id,
          data: rectAttr
        }
        this.$store.dispatch(this.request_prefix + "/addElement", params)
        let newIndex = param.index
        const allRects = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
          container_id: this.ids.container_id
        }).children
        let _rect_id = -1
        if (allRects.length > 0) {
          _rect_id = smartMathMax(
            ...allRects.map(function (o) {
              return o.rect_id
            })
          )
        }
        let rect_id = _rect_id
        if (type === "addBtn" && typeof newIndex !== "undefined") {
          // 添加锚点按钮逻辑
          param.cellRect.splice(newIndex, 0, rect_id)
        } else {
          if (typeof newIndex !== "undefined") {
            param.cellRect.splice(newIndex, 1, rect_id)
          } else {
            param.cellRect.push(rect_id)
          }
        }
      }
    },
    // 获取最新的布局id
    getNewLayoutId() {
      let id = 1
      this.pageLayoutList.forEach(item => {
        id = item.id && item.id >= id ? item.id + 1 : id
      })
      // 不存在的话，默认为null，转为number后为0。之所以要存储在本地，是因为有可能组件已经删除，新增布局，恢复后id会重复
      const maxLayoutId = sessionStorage.getItem("maxLayoutId")
      id = Math.max(id, +maxLayoutId)
      sessionStorage.setItem("maxLayoutId", id + 1)
      return id
    },
    resetRectAttrOpt(childItem, _attribute) {
      this.needHid = true
      let layoutUidMap = {}
      childItem.encId ? (_attribute.moduleId = childItem.encId) : ""
      childItem.typeId ? (_attribute.typeId = childItem.typeId) : ""
      //鼠标移动处理
      if (this.request_prefix === "appStage" && _attribute.options.width > 414) {
        _attribute.options.width = 414
      }
      if (_attribute.shape === "layoutComponent" || "emptyLayoutComponent") {
        //递归修改uid 把menu里的默认uid（会导致cols的id值重复）修改为随机生成的uid
        layoutUidMap = deepChangeUid(_attribute)
      }
      _attribute.options.layoutUidMap = layoutUidMap
      this.rectAttr = _attribute
    },
    computedTextStyle(style) {
      return {
        lineHeight: `${style.lineHeight}px`,
        fontSize: `${style.fontSize}px`,
        backgroundColor: style.bgColor,
        color: style.color,
        fontWeight: style.fontWeight
      }
    },
    computedButtonStyle(style) {
      return {
        lineHeight: `${style.height}px`,
        width: `${style.width}px`,
        fontSize: `${style.fontSize}px`,
        borderRadius: `${style.hoverBorderBottomRightRadius}px`,
        backgroundColor: style.bgColor,
        color: style.color,
        border: `${style.borderWidth}px ${style.borderStyle} ${style.borderColor}`,
        boxShadow: `${style.boxShadowH}px ${style.boxShadowV}px  ${style.boxShadowBlur}px  ${style.boxShadowSpread}px ${style.boxShadowColor}`
      }
    },
    handleChange() {},
    GetRequestAdmin(label) {
      var url = location.href //获取url中"?"符后的字串
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
        var str = url.split("?")[1]
        var strs = str.split("&")
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1])
        }
      }
      let val = theRequest[label]
      return val
    },
    isNeedShow(item) {
      let type = item.type
      let flag = true
      let isAdmin = this.$store.state.states.managerType === 1 ? true : false
      if (type === "cxSystemNav" && this.request_prefix === "appStage" && !isAdmin) {
        flag = false
      }
      if (type === "cxSmartServices") {
        // 如果当前单位没有开通机器人 则不返回
        let robotList = sessionStorage.getItem("robotList")
        robotList = robotList ? JSON.parse(robotList) : []
        if (robotList.length === 0) flag = false
      }
      if (item.name.includes("布局")) {
        let enable = item.attribute?.options?.enable
        if (enable === undefined || enable === null) flag = true
        if (typeof enable === "function") {
          flag = isAdmin
        }
      }
      return flag
      // return true
    },
    showDeleteIcon(index) {
      this.showCollectDeleteIconIndex = index
    },
    hideDeleteIcon() {
      this.showCollectDeleteIconIndex = null
    },
    delCollect(param) {
      const self = this
      if (param.encId) {
        instance
          .post(`v2/${param.encId}/remove`)
          .then(() => {
            initModules.call(self)
          })
          .catch(err => {})
      }
    },
    // 设为模板
    handleParam(encAppId) {
      const _ids = this.ids
      let content = JSON.parse(
        JSON.stringify(
          this.$store.state[this.request_prefix].page.children.find((val, index, arr) => {
            if (val.container_id === _ids.container_id) {
              return val
            }
          })
        )
      )
      content.isActive = false
      content.container_id = undefined
      content = encryption(content, data_dictionary_map)
      const param = {
        c: content,
        a: encAppId
      }
      return param
    },
    saveStageModuleEv() {
      if (this.collectModuleForm.name !== null) {
        const { pageId, wfwfid } = this.$store.state.states.getDataPageIds
        const _self = this
        const params = {
          a: "7C5C8F204A2F4171",
          w: wfwfid,
          p: pageId,
          t2: "20106053E31351DC",
          t: _self.collectModuleForm.name
        }
        this.$API
          .createComponentApp({
            param: params
          })
          .then(res => {
            if (res.data.data.moduleId) {
              initStageModules.call(_self)
              _self.collectModuleForm.name = null
              _self.collectModuleForm.type = null
              _self.$message({
                customClass: "bigScreen_msg_backGroud",
                duration: 3000,
                type: "success",
                message: "保存成功"
              })
              _self.dialogFormVisible = false
            }
          })
          .catch(err => {})
      } else {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "您输入的数据不正确，请检查内容",
          type: "error"
        })
      }
    },
    canDraggle(item) {
      if (item.type === "cxBayWindow" || item.type === "cxHeader" || item.type === "cxFooter" || item.type === "cxAnchor") {
        return false
      }
      return true
    },

    // 获取数据的函数
    async getAllStyles(type) {
      if(!this.collectNewVersion){
        return
      }
      if (this.styleIdArr.length === 0) {
        return
      }
      let res = ""
      if(type){
        // 按照分类查看
        res = await this.$API.collectListsType({
          param: this.styleIdArr1,
        })
        if(res.data.data){
          this.collectListsTypeData = res.data.data
          this.collectListsTypeShow = []
          this.activeNamesCollect = []
          for(let key in this.collectListsTypeData){
            let index = this.styleIdArr1.indexOf(key)
              if(index > -1 && this.collectListsTypeData[key]){
                let obj = {}
                obj.publicId = key
                obj.name = this.styleIdArr[index].name
                obj.content = this.collectListsTypeData[key].list
                obj.listInfo = this.collectListsTypeData[key]
                this.collectListsTypeShow.push(obj)
                this.activeNamesCollect.push(this.collectListsTypeShow.length)
              }
          }
        }
      }
      else {
        this.collectListsAllData = []
        // 不按照分类查看
        res = await this.$API.collectListsAll({
          typeIds: this.styleIdArr1,
          p2: 10,
          p: 1,
        })
        if(res.data.data){
          this.totalPage = res?.data?.data?.pages
          this.allStyleLen = res?.data?.data?.total
          this.collectListsAllData = res?.data?.data?.list
          if(this.collectListsAllData.length > 0){
            this.collectListEmpty = false
            // 若存在多页，继续请求下一页
            let data1 = res?.data?.data
            if(data1.pageNum < data1.pages){
              this.isLoading = false
              this.hasMore = true
              this.curPage = 2;
              this.fetchData(false)
            }
          }else{
            this.collectListEmpty = true
          }
        }
      }
    },
    async fetchData() {
      if (this.isLoading || !this.hasMore) return;
      this.isLoading = true
      try {
        // 不按照分类查看
       let res = await this.$API.collectListsAll({
          typeIds: this.styleIdArr1,
          p2: 10,
          p: this.curPage,
        })
        if(res.data.data){
          this.collectListsAllData = [...this.collectListsAllData, ...res?.data?.data?.list];
          // 如果获取到的数据长度小于pageSize，则说明没有更多数据了
          if (this.collectListsAllData.length === this.allStyleLen) {
            this.hasMore = false;
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      this.isLoading = false;
      this.$nextTick(() => {
        this.listenerScroll()
      })
    },
    listenerScroll() {
      let _this = this
      _this.$refs.scrollbar.wrap.onscroll = e => {
        let height = e.target.scrollHeight - e.target.clientHeight
        if (
            (height == e.target.scrollTop || height - e.target.scrollTop === 1 || height - e.target.scrollTop < 1) &&
            height != 0 &&
            _this.curPage < _this.totalPage
        ) {
          this.isLoading = false
          _this.curPage += 1
          _this.fetchData(false)
        }
      }
    },
    // 点击查看更多
    async loadMoreFunc(item, index, contentLen) {
      let pageNum = Math.ceil(contentLen / 6) + 1
      let res = await this.$API.collectListsTypeMore({
        typeIds: item.publicId,
        p: pageNum,
        p2: 6
      })
      if(res.data.code === 1){
        let PageInfo = res?.data?.data?.PageInfo
        this.collectListsTypeData[item.publicId].list = [...this.collectListsTypeData[item.publicId].list, ...PageInfo?.list]
        this.collectListsTypeShow[index].content = [...this.collectListsTypeShow[index].content, ...PageInfo?.list]
        this.collectListsTypeShow[index].listInfo = PageInfo
      }
    },
    handleCommand(command) {
      if(command.val === "rename"){
        this.openRenameDialog(command)
      } else if(command.val === "delete"){
        this.delComponent(command)
      }
    },
    // 打开重命名弹窗
    openRenameDialog(command) {
      this.dialogRenameVisible = true
      this.collectRenameObj.title = command.item.title
      this.collectRenameObj.publicId = command.item.publicId
      this.collectRenameObj.cover = command.item.cover
      if(this.componentViewType){
        this.collectRenameObj.itemPath = [command.index, command.index2]
      }else{
        this.collectRenameObj.itemPath = command.index
      }
    },
    // 关闭重命名弹窗
    closeRenameDialog() {
      this.dialogRenameVisible = false
      this.collectRenameObj.title = ""
      this.collectRenameObj.publicId = ""
      this.collectRenameObj.cover = ""
      this.collectRenameObj.itemPath = ""
    },
    //收藏重命名
    async renameCollectFunc() {
      let res = await this.$API.collectCoverNameChange({
        publicId: this.collectRenameObj.publicId,
        // cover: this.collectRenameObj.cover,
        title: this.collectRenameObj.title
      })
      if(res?.data?.code === 1){
        if(this.componentViewType){
          let itemPath = this.collectRenameObj.itemPath
        //   按照分类
          this.collectListsTypeShow[itemPath[0]].content[itemPath[1]].title = this.collectRenameObj.title
        }else{
          //   不按照分类
          this.collectListsAllData[this.collectRenameObj.itemPath].title = this.collectRenameObj.title
        }
        this.closeRenameDialog()
      }
    },
  //  删除收藏的组件
    delComponent(command) {
      let param = command.item
      if (param.publicId) {
        this.$confirm("确认删除吗？", "", {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          showClose: false,
          dangerouslyUseHTMLString: "<p>确认删除吗？</p>",
          iconClass: "bigScreen_confirm_icon el-icon-warning",
          cancelButtonClass: "bigScreen_confirm_cancel_button",
          confirmButtonClass: "bigScreen_confirm_button",
          customClass: "bigScreen_confirm custom_warning_dialog"
        })
          .then(() => {
            instance
                .post(`v2/${param.publicId}/remove`)
                .then(() => {
                  if(this.componentViewType){
                    //   按照分类
                    this.collectListsTypeShow[command.index].content.splice(command.index2, 1)
                  }else{
                    //   不按照分类
                    this.collectListsAllData = []
                  }
                  // 重新获取数据
                  this.getAllStyles(this.componentViewType)
                })
                .catch(err => {})
          })
          .catch(() => {})
      }
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep.left-menu-tabs {
  height: 100%;
  user-select: none;
}
::v-deep .el-tabs__nav-wrap::after {
  background-color: transparent;
}
::v-deep.left-menu-tabs .el-tabs__header {
  margin: 0;
}
::v-deep.left-menu-tabs .el-tabs__nav {
  display: flex;
  width: 100%;
  padding-left: 6px;
}
::v-deep .left-menu-tabs .el-tabs__item {
  /*flex: 1;*/
  text-align: center;
  padding: 0 8px 0 8px;
  line-height: 48px;
  height: 48px;
  font-size: 16px;
}
::v-deep .left-menu-tabs.el-tabs--top .el-tabs__item.is-top:nth-child(2){
  padding: 0 8px 0 8px;
}
::v-deep .left-menu-tabs .el-tabs__item.is-active {
  /*color: var(--themeColor);*/
  color: rgba(0, 0, 0, 0.8);
}
::v-deep .left-menu-tabs .el-tabs__item.is-active:after {
  display: block;
  position: absolute;
  bottom: 0;
  left: 50%;
  height: 2px;
  width: 100%;
  content: "";
  max-width: 150px;
  transform: translateX(-50%);
  background: linear-gradient(
    90deg,
    rgba(196, 196, 196, 0.27125) 0%,
    rgba(23, 112, 255, 0) 0%,
    var(--themeColor) 50%,
    rgba(23, 112, 255, 0) 100%
  );
  opacity: 0;
}
::v-deep .left-menu-tabs .el-tabs__item:hover{
  color: var(--themeColor);
}
::v-deep .left-menu-tabs .el-tabs__active-bar {
  background-color: var(--themeColor);
}
::v-deep.left-menu-tabs .el-tabs__active-bar {
  /*width: 33.3% !important;*/
  width: 25%;
  display: none;
}
.left_menu {
  height: 100%;
}
::v-deep .el-tabs__content {
  height: calc(100% - 48px);
  overflow-y: auto;
  width: calc(100% + 18px);
  box-sizing: border-box;
}
::v-deep .el-tabs__content .el-collapse-item__wrap {
  width: 222px !important;
}
::v-deep .el-collapse-item__content {
  font-size: 14px;
  padding-bottom: 0;
}
::v-deep .el-collapse-item__header,
::v-deep .el-collapse {
  border: none;
}
::v-deep .el-collapse,
::v-deep .el-collapse-item,
::v-deep .el-collapse-item__wrap {
  border-bottom: none;
}

.left-home ::v-deep .el-collapse-item {
  border-bottom: none;
}
::v-deep .el-collapse-item:last-child {
  margin-bottom: 36px;
}
.menu_item_content_ul {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
  > li {
    box-sizing: border-box;
    cursor: grab;
    text-align: center;
    position: relative;
    &:hover {
      border: 1px solid var(--themeColorIcon);
      border-radius: 4px;
      p {
        font-weight: 600;
      }
    }
    &:active {
      cursor: grabbing;
    }
    p {
      line-height: 18px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-top: 4px;
      font-size: 12px;
    }
    .menu-icon {
      display: inline-block;
      width: 32px;
      height: 32px;
      font-size: 32px;
      margin: 0 auto;
      color: var(--themeColorIcon);
    }
    .deleteCollect {
      position: absolute;
      top: -20px;
      right: 0;
      cursor: pointer;
    }
  }
}
::v-deep .el-collapse-item__header {
  padding: 0 24px;
  box-sizing: border-box;
  height: 44px;
  line-height: 44px;
}
.left-home {
  .menu_item_content_ul {
    padding: 10px 6px;
    box-sizing: border-box;
    > li {
      width: 33.3%;
      margin: 0;
      padding: 8px 0;
      border: none;
      font-size: 0;
      &:hover {
        border: none;
        background-color: var(--themeColorIconHover);
        p {
          font-weight: 400;
        }
        .menu-hidden {
          display: inline-block;
        }
      }
      .menu-icon {
        width: 24px;
        height: 24px;
        font-size: 24px;
        margin: 0 auto;
      }
      .menu-hidden {
        width: 14px;
        height: 14px;
        font-size: 14px;
        display: none;
        position: absolute;
        top: 6px;
        right: 4px;
        color: var(--themeColorIcon);
      }
    }
  }
  ::v-deep .el-collapse-item__header {
    padding: 0 12px 0 30px;
    height: 34px;
    line-height: 34px;
  }
}
::v-deep.left_menu > .el-collapse {
  padding-bottom: 50px;
}
#addPhonePage {
  width: 208px;
  border: 1px solid;
  color: var(--themeColor);
  line-height: 30px;
  border-radius: 4px;
  text-align: center;
  margin: 16px auto;
  cursor: pointer;
  .icon {
    display: inline-block;
    margin-right: 2px;
  }
  &:hover {
    background: var(--themeColorSelectBg);
  }
}
.leftPagelist {
  > li {
    position: relative;
    text-align: center;
    padding: 8px 12px 12px;
    box-sizing: border-box;
    cursor: pointer;
    .add-new-stage {
      position: absolute;
      display: none;
      left: 50%;
      bottom: 2px;
      font-size: 12px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      margin-left: -10px;
      background-color: var(--themeColor);
      padding: 0;
      color: #fff;
    }
    .page-handles {
      visibility: hidden;
    }
    &:hover {
      color: var(--themeColor);
      .page-handles {
        visibility: visible;
      }
      .add-new-stage {
        display: block;
      }
      .scan-page {
        border: 1px solid var(--themeColor);
      }
    }
    .scan-page {
      width: 112px;
      height: 179px;
      border: 1px solid var(--borderColorFour);
    }
    &.active {
      background-color: var(--themeColorSelectBg);
      color: var(--themeColor);
      cursor: move;
      .scan-page {
        border: 1px solid var(--themeColor);
        box-shadow: 0 0 0 1px var(--themeColor);
      }
      .page-handles {
        visibility: visible;
      }
    }
    .icon {
      display: block;
      font-size: 16px;
      margin: 20px auto;
      color: var(--subTextColor);
      cursor: pointer;
      width: 28px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      border-radius: 4px;
      &:hover {
        background-color: var(--iconHoverBgColor);
      }
    }
  }
}
.left-home .left-menu-tabs ::v-deep .el-collapse-item__arrow {
  transform: rotate(0);
  color: var(--thirdTextColor);
  position: absolute;
  left: 12px;
}
.left-home .left-menu-tabs ::v-deep .el-collapse-item__arrow::before {
  content: "\e791";
}
.left-home .left-menu-tabs ::v-deep .el-collapse-item__arrow.is-active {
  transform: rotate(90deg);
}
::v-deep.pagination .el-pagination {
  margin: 0 auto;
}
::v-deep.pagination .el-pagination .btn-next,
::v-deep.pagination .el-pagination .btn-prev {
  background-color: transparent;
  color: var(--text);
}
::v-deep.pagination .el-pager li {
  background-color: transparent;
  color: var(--text);
}
::v-deep.pagination .el-pager li.active {
  color: var(--themeColor);
}
.widthLess18{
  width: calc(100% - 18px);
}
.width222{
  width: 222px;
}
.data-empty{
  color: rgba(0, 0, 0, 0.4);
  line-height: 22px;
  padding: 60px 22px 0;

  img{
    width: 140px;
    height: 100px;
    margin-bottom: 16px;
  }
}
.scroll-container {
  padding: 0 6px;
}
.collect-data-list {
  height: auto; /* 根据实际内容高度来 */
  .data-item {
    /*width: calc(50% - 4px);*/
    width: 94px;
    display: inline-block;
    margin: 6px 4px;
    .cover-img{
      position: relative;
      background-color: rgba(247, 248, 250, 1);
      border: 1px solid rgba(233, 233, 233, 1);
      padding: 8px;
      border-radius: 4px;
      height: 75px;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        max-width: 100%;
        max-height: 100%;
      }
      .hover-btn{
        position: absolute;
        top: 1px;
        right: 1px;
        .icon-portal-more{
          background-color: white;
          border: 1px solid rgba(233, 233, 233, 1);
          -webkit-border-radius: 4px;
          -moz-border-radius: 4px;
          border-radius: 4px;
          opacity: 0;
        }
        &:hover{
          .icon-portal-more{
            color: var(--themeColor);
          }
        }
      }
    }
    .cover-name{
      margin-top: 4px;
      color: rgba(0, 0, 0, 0.8);
      line-height: 16px;
    }
    &:hover{
      .cover-img {
        border-color: rgba(156, 194, 255, 1);
        .hover-btn .icon-portal-more{
          opacity: 1;
        }
      }
    }
  }
  .type-lists{
    .data-item{
      width: calc(50% - 8px);
    }
  }
  .btn-more{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
::v-deep .el-tabs__content .collect-data-list .el-collapse-item__wrap {
  width: auto !important;
}
.collect-data-list ::v-deep .el-collapse-item__header{
  background: transparent !important;
  padding-left: 18px;
}
.loading-text {
  text-align: center;
  padding: 10px;
  color: rgba(0, 0, 0, 0.4);
}
::v-deep #pane-fourth.el-tab-pane{
  height: 100%;
}
.operate-list .el-dropdown-menu__item{
   padding: 0 12px;
}
</style>
<style>
.left-menu-tooltip.el-tooltip__popper {
  background: rgba(0, 13, 34, 0.9);
}
.left-menu-tooltip.el-tooltip__popper .popper__arrow::after {
  border-top-color: rgba(0, 13, 34, 0.9);
}
.menu_dis_chosen {
  opacity: 0.4;
}
.padding12{
  padding: 12px;
}
.paddinglr6{
  padding-left: 6px;
  padding-right: 6px;
}
  .color0006{
    color: rgba(0, 0, 0, 0.6);
  }
  .lineHeight24{
    line-height: 24px;
  }
</style>

